/*
 * @Description: 
 * @Author: liushuai
 * @LastEditTime: 2020-09-22 11:08:01
 */
import PropTypes from 'prop-types';
import noop from '../_util/noop'; // 公共部分

export var propTypes = {
  prefixCls: PropTypes.string,
  visible: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  onCancle: PropTypes.func,
  onOk: PropTypes.func,
  render: PropTypes.func,
  categoryRender: PropTypes.func,
  api: PropTypes.func,
  value: PropTypes.array,
  maxSize: PropTypes.number,
  data: PropTypes.array,
  keyName: PropTypes.string,
  categoryKeyName: PropTypes.string,
  keywordKeyName: PropTypes.string,
  showSearch: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  params: PropTypes.object,
  zIndex: PropTypes.number,
  cipher: PropTypes.bool
}; // 公共部分

export var defaultPropTypes = {
  prefixCls: 'mkui-transfer-modal',
  onOk: null,
  onCancle: null,
  render: null,
  categoryRender: null,
  multiple: true,
  visible: false,
  title: '',
  subTitle: '',
  value: [],
  data: [],
  api: null,
  maxSize: 10,
  keyName: 'code',
  categoryKeyName: 'code',
  keywordKeyName: 'keyword',
  showSearch: false,
  searchPlaceholder: '输入查询关键字',
  zIndex: undefined,
  cipher: false
};
//# sourceMappingURL=PropTypes.js.map
